import { NaiveDate } from "@tento-chrono";
import { type CellEntry, Json } from "@tento-lona/sheets";
import { calendarSystemCellData } from "@tento-lona/sheets/platform";
import type { CellProvider } from "../rows/row-descriptor.ts";
import type { SheetRow } from "../rows/sheet-row.ts";

/**
 * The SDK's `calendar-system` cell provider: one cell per day of the range,
 * the secondary-calendar label of the row's `calendarSystem` attribute. It
 * adapts the rows-side computation (`calendarSystemCellData`, what
 * `CalendarSystemRow` computes) — one normalization (a leading `:` is
 * dropped, `gregorian` included), one converter table, one cache — so the
 * SDK and the rows-side row never disagree on a label.
 */
export class CalendarSystemProvider implements CellProvider {
  readonly kind = "calendar-system";

  computeCells(range: NaiveDate.Range, row: SheetRow): CellEntry[] {
    const system = Json.string(row.attributes(), "calendarSystem") ?? "";
    const entries: CellEntry[] = [];
    for (const date of range.iter()) {
      const value = calendarSystemCellData(system, date);
      if (value == null) continue;
      entries.push({ date: new NaiveDate.Partial("day", date.yr, date.month1, date.day1), id: null, value, style: null });
    }
    return entries;
  }
}

/** Singleton — one provider handles all calendar systems at compute time. */
export const CALENDAR_SYSTEM_PROVIDER = new CalendarSystemProvider();
